import { WortUnits } from '../provider/types';

export const getWortUnitSymbol = (wortUnit: WortUnits) => {
  const units = {
    [WortUnits.Hectorliter]: 'hl',
    [WortUnits.Liter]: 'l',
    [WortUnits.Gallon]: 'gal',
    [WortUnits.Barrels]: 'bbl',
    [WortUnits.Gram]: 'gm',
    [WortUnits.Kilogram]: 'kg',
    [WortUnits.Pound]: 'pound',
    [WortUnits.Ounce]: 'ounce',
    [WortUnits.Mililiter]: 'ml',
  };
  return units[wortUnit];
};
